import "./Loader.css"

const index = () => {
  return (
    <div className="centerContent z-50 absolute w-full h-full bg-white/70 top-0 left-0">
        <div className="loader"></div>
    </div>
  )
}

export default index